export const getWeatherInfo = (
  weathercode: number,
  isNight: boolean
): { emoji: string; description: string } => {
  let emoji: string;
  let description: string;

  switch (weathercode) {
    case 0:
      emoji = isNight ? "🌕" : "☀️"; // Clear sky
      description = "Clear sky";
      break;
    case 1:
      emoji = isNight ? "🌖" : "🌤️"; // Mainly clear
      description = "Mainly clear";
      break;
    case 2:
      emoji = isNight ? "🌗" : "⛅"; // Partly cloudy
      description = "Partly cloudy";
      break;
    case 3:
      emoji = "☁️"; // Overcast
      description = "Overcast";
      break;
    case 45:
    case 48:
      emoji = "🌫️"; // Fog
      description = "Fog";
      break;
    case 51:
    case 53:
    case 55:
      emoji = "🌦️"; // Drizzle
      description = "Drizzle";
      break;
    case 56:
    case 57:
      emoji = "🌧️"; // Freezing Drizzle
      description = "Freezing drizzle";
      break;
    case 61:
    case 63:
    case 65:
      emoji = "🌧️"; // Rain
      description = "Rain";
      break;
    case 66:
    case 67:
      emoji = "🌨️"; // Freezing Rain
      description = "Freezing rain";
      break;
    case 71:
    case 73:
    case 75:
    case 77:
      emoji = "❄️"; // Snow fall
      description = "Snowfall";
      break;
    case 80:
    case 81:
    case 82:
      emoji = "🌧️"; // Rain showers
      description = "Rain showers";
      break;
    case 85:
    case 86:
      emoji = "❄️"; // Snow showers
      description = "Snow showers";
      break;
    case 95:
      emoji = "⛈️"; // Thunderstorm
      description = "Thunderstorm";
      break;
    case 96:
    case 99:
      emoji = "⛈️"; // Thunderstorm with hail
      description = "Thunderstorm with hail";
      break;
    default:
      emoji = "🌡️"; // Unknown weather code
      description = "Unknown weather condition";
      break;
  }

  return { emoji, description };
};
